<template>
  <div class="remove-link cursor-pointer" @click="remove()">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ['actionUrl', 'successUrl'],
  methods: {
    remove: function () {
      this.$confirm(
          {
            message: `Wirklich unwiderruflich 🙈🙈🙈 löschen?`,
            button: {
              no: 'Abbrechen',
              yes: 'Löschen'
            },
            /**
             * Callback Function
             * @param {Boolean} confirm
             */
            callback: confirm => {
              if (confirm) {
                this.performDelete();
              }
            }
          }
      )
    },
    performDelete: function () {
      this.$http['delete'](this.actionUrl).then(response => {
        window.location.href = this.successUrl
      }, response => {

      })
    }
  }
}
</script>